/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `DOC_FEE` - Documentation Fee
 * * `ACCUMULATED` - Total accumulated local costs
 * * `OTHER` - Other
 */
export type LocalCostResultDTOCategoryEnum = typeof LocalCostResultDTOCategoryEnum[keyof typeof LocalCostResultDTOCategoryEnum];


export const LocalCostResultDTOCategoryEnum = {
  DOC_FEE: 'DOC_FEE',
  ACCUMULATED: 'ACCUMULATED',
  OTHER: 'OTHER',
} as const;
